import React, { memo, useEffect, useState, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import CircularProgress from '@material-ui/core/CircularProgress'
import { toast } from 'react-toastify'

import classes from './styles.module.scss'
import { StoreValue, ConfirmEmail } from 'store'
import { parseQuery } from 'utils'

const EmailConfirmed: React.FunctionComponent<any> = () => {
	const { i18n, t } = useTranslation()
	const history = useHistory()
	const [loading, setLoading] = useState(true)
	// Todo Kundan1023
	const [confirmEmailMutation] = useMutation(ConfirmEmail)
	const messageText = useRef(
		t(
			`Email verified successfully, you will receive the email with the QR code for StudentsKit`,
		),
	)
	const url: { data: string } = parseQuery(window.location.search)
	const buff = Buffer.from(url.data, 'base64')
	const decodedData = buff.toString('utf-8')
	const decodedDataParsed: { id: string; pin: string } =
		JSON.parse(decodedData)

	const goToHomePage = useCallback(() => {
		history.push(`/${i18n.language}`)
	}, [history, i18n.language])

	// mark the email as verified and send the QR code
	useEffect(() => {
		if (loading) {
			confirmEmailMutation({
				variables: {
					language: i18n.language,
					id: decodedDataParsed.id,
					pin: decodedDataParsed.pin,
				},
			})
				.then(response => {
					if (response.data.confirmEmail === null) {
						messageText.current = t(
							'Your email has already been confirmed',
						)
					}
					setLoading(false)
				})
				.catch(error => {
					toast.error(t('Sorry ... something went wrong'), {
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
					})
					history.push(`/${i18n.language}`)
				})
		}
	}, [
		confirmEmailMutation,
		decodedDataParsed.id,
		decodedDataParsed.pin,
		history,
		i18n.language,
		loading,
		t,
	])

	return loading ? (
		<CircularProgress size={40} style={{ margin: 'auto' }} />
	) : (
		<div className={classes.container}>
			<Row className={classes.infoText} gutter={8}>
				<Col sm={{ span: 24 }}>
					<div className={classes.infoText}>
						{t(messageText.current)}
					</div>
				</Col>
			</Row>
			<Row>
				<Col sm={{ span: 24 }}>
					<div className={classes.button}>
						<Button type="primary" onClick={goToHomePage}>
							{t('Go to home page')}
						</Button>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default memo((props: any) => (
	<StoreValue keys={['user|storeUser']}>
		<EmailConfirmed {...props} />
	</StoreValue>
))
